<template>

	<div class="container recharge ">
		<div class="bg-mine">
			<!-- 头像 -->
			<div class="bg-mine-portrait"><img  src="/static/images/photo.png" /></div>
			<!-- name -->
			<div class="bg-mine-name">
				<p >王某某</p>
			</div>


		</div>
		<div class="history-title">  
			<div> 充值历史</div>
		</div>
		<div class="weui-grids"> 


			<router-link  :to="{path:'/historycard',query:{params:1}}" class="weui-grid js_grid" hover-class="a-hover">
				<div class="weui-grid__icon">
					<img src="/static/images/icon3.png" alt=""/>
				</div>
				<div class="weui-grid__label">
					水费订单
				</div>
			</router-link>



			<router-link  :to="{path:'/historycard',query:{params:2}}" class="weui-grid js_grid" hover-class="a-hover">
				<div class="weui-grid__icon">
					<img src="/static/images/icon2.png" alt=""/>
				</div>
				<div class="weui-grid__label">
					电费订单
				</div>
			</router-link>
			<router-link  :to="{path:'/historycard',query:{params:3}}"  url="javascript:;" class="weui-grid js_grid" hover-class="a-hover">
				<div class="weui-grid__icon">
					<img src="/static/images/icon1.png" alt=""/>
				</div>
				<div class="weui-grid__label">
					网费订单
				</div>
			</router-link>
		
		<router-link  :to="{path:'/historycard',query:{params:4}}" class="weui-grid js_grid" hover-class="a-hover">
			<div class="weui-grid__icon">
				<img src="/static/images/icon4.png" alt=""/>
			</div>
			<div class="weui-grid__label">
				话费订单
			</div>
		</router-link>
		<router-link  :to="{path:'/historycard',query:{params:5}}" url="javascript:;" class="weui-grid js_grid" hover-class="a-hover">
			<div class="weui-grid__icon">
				<img src="/static/images/icon5.png" alt=""/>
			</div>
			<div class="weui-grid__label">
				电信订单
			</div>
		</router-link>
	</div>
	<div class="clear" style="margin-top:   50px"> </div>
</div>
	


</template>
<script>
export default{
	name:'rehistory',


}
</script>
<style >
body{
	margin:0;
}
.bg-mine {
  width: 100%;
  height: 180px;
  background: green;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to bottom right, #e4393c, #ecd533)
}

.bg-mine .bg-mine-portrait {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border-radius: 50%
}

.bg-mine .bg-mine-portrait img{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover
}

.bg-mine .bg-mine-name {
  font-size: 14px;
  color: #fff;
  line-height: 30px;
  height: 30px
}

.weui-grid {
  position: relative;
  float: left;
  padding: 10px 5px;
  width: 50%;
  box-sizing: border-box;
  text-decoration:none;
}

.weui-grid .weui-grid__label {
  margin-top: 5px;
  display: block;
  text-align: center;
  color: #666;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden
}

.weui-grid:before {
  content: " ";
  position: absolute;
  right: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-right: 1px solid #D9D9D9;
  color: #D9D9D9;
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5)
}

.weui-grid:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #D9D9D9;
  color: #D9D9D9;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5)
}

.weui-grids {
  position: relative;
  overflow: hidden;
  background-color: #fff
}

.weui-grids:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid #D9D9D9;
  color: #D9D9D9;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5)
}
.weui-grids:after{
	    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    bottom: 0;
    border-left: 1px solid #D9D9D9;
    color: #D9D9D9;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
}


.weui-grid__icon {
  width: 28px;
  height: 28px;
  margin: 0 auto;
  overflow: hidden
}

.weui-grid__icon img{
  width: 28px;
  height: 28px;
}

.history-title {
  padding: 10px;
  font-size:14px;
  font-weight: 700;
  color: #333;

}
.navigator-hover{
  opacity: .8;
  background-color:#ddd;
}
</style>


// WEBPACK FOOTER //
// src/page/rehistory.vue